import { memo } from 'react';
function GeofenceIcon({ color = '#808080', size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.375 3H85.5V49.125L70.125 79.875L29.125 85L3.5 59.375L8.625 18.375L39.375 3Z"
        stroke={color}
        strokeWidth="6"
      />
    </svg>
  );
}

export default memo(GeofenceIcon);
